import { Button } from "@/components/ui/button";
import { AlertTriangle, Inbox, RotateCw } from "lucide-react";

/**
 * Zentrale, wiederverwendbare Listen-Zustände (Design-System, Phase C):
 * Leerzustand, Fehlerzustand und Karten-/Zeilen-Skeletons.
 */
export function EmptyState({ icon: Icon = Inbox, title = "Keine Einträge", description, action, testid = "empty-state" }) {
  return (
    <div className="flex flex-col items-center text-center" data-testid={testid}>
      <Icon className="w-14 h-14 text-muted-foreground/30" strokeWidth={1.5} />
      <h3 className="text-lg font-medium mt-4">{title}</h3>
      {description && <p className="text-muted-foreground mt-1 text-sm max-w-sm">{description}</p>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}

export function ErrorState({ message = "Die Daten konnten nicht geladen werden.", onRetry, testid = "error-state" }) {
  return (
    <div className="flex flex-col items-center text-center" data-testid={testid}>
      <div className="w-14 h-14 rounded-full bg-destructive/10 flex items-center justify-center">
        <AlertTriangle className="w-7 h-7 text-destructive" strokeWidth={1.75} />
      </div>
      <h3 className="text-lg font-medium mt-4">Etwas ist schiefgelaufen</h3>
      <p className="text-muted-foreground mt-1 text-sm max-w-sm">{message}</p>
      {onRetry && (
        <Button variant="outline" className="mt-4" onClick={onRetry} data-testid={`${testid}-retry`}>
          <RotateCw className="w-4 h-4 mr-2" />
          Erneut versuchen
        </Button>
      )}
    </div>
  );
}

export function CardSkeleton({ count = 5 }) {
  return (
    <div className="space-y-2" data-testid="card-skeleton">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="rounded-xl border border-border bg-card p-4">
          <div className="h-4 w-1/2 rounded bg-muted animate-pulse" />
          <div className="h-3 w-1/3 rounded bg-muted animate-pulse mt-3" />
          <div className="h-3 w-2/3 rounded bg-muted animate-pulse mt-2" />
        </div>
      ))}
    </div>
  );
}
